import React from 'react';
import {connect} from 'react-redux';
import DefaultPage from '../../views/Default/Default'; 
import TableBuilder from '../../tableBuilder/TableBuilder';
import FormBuilder from '../../formBuilder/FormBuilder';
import './View.css'
import RomanianPackage from '../../languages/RomanianPackage';
import ReportsView from '../../views/Reports/Reports';

class View extends React.Component {

    determineView () {
        if (!this.props.view) {
            return <DefaultPage />
        }

        switch(this.props.view.viewType) {

            case 'TableBuilder':
                return <TableBuilder />

            case 'TableBuilderWithForm':
                return <div>
                    <FormBuilder />
                    <TableBuilder />
                </div>
            case 'Reports':
                return <ReportsView />
            default: 
                return <DefaultPage />
        }
    }

    render(){

        return (

        <div className='view'>
        {this.props.view ? <h2>{RomanianPackage[this.props.view.defaultName]}</h2> : null}
            {this.determineView()}
        </div>
            
        )
    }
}

function mapStateToProps(state) {

    return {
        columns: state.table.columns,
        data: state.table.data,
        view: state.activeOption
    }
}

export default connect(mapStateToProps)(View);


// WEBPACK FOOTER //
// ./src/containers/view/View.js